import React from 'react';
import { Button } from './Button';
import { ArrowRight } from 'lucide-react';
export const CallToAction = () => {
  return <section id="cta" className="w-full bg-white py-section-mobile md:py-section-desktop relative overflow-hidden" data-id="element-38">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-39">
        <div className="max-w-6xl mx-auto" data-id="element-40">
          <div className="grid lg:grid-cols-12 gap-8 lg:gap-20 items-center" data-id="element-41">
            <div className="lg:col-span-12" data-id="element-42"></div>
            <div className="lg:col-span-12" data-id="element-43">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3KFpKL4x8ZRHY6kZ6KEr1H/image.png" alt="Decorative divider with plant illustrations" className="w-full mx-auto mb-8" data-id="element-44" />
              <div className="bg-gradient-to-br from-primary-50 to-blue-50 rounded-2xl shadow-glow p-4 md:p-8 lg:p-10 space-y-8 border border-primary-100 transition-all duration-300 hover:shadow-glow-hover backdrop-blur-sm lg:max-w-[80%] lg:mx-auto" data-id="element-45">
                <h2 className="text-h2-mobile md:text-h2-desktop font-serif font-normal text-cyan-800 mb-4 leading-tight text-center" data-id="element-46">
                  Nisa is now open
                </h2>
                <div className="space-y-6 md:space-y-8 max-w-[80%] mx-auto" data-id="element-47">
                  <p className="text-base font-medium md:text-lg text-gray-600 leading-relaxed text-center" data-id="element-48">
                    Our pilot phase is complete. Nisa is ready to support
                    instructional coaches across the country.
                  </p>
                  <p className="text-base md:text-lg text-gray-600 leading-relaxed text-center" data-id="element-49">
                    Whether you're supporting 6 teachers or 60, Nisa is here to
                    make your day-to-day more intentional, less overwhelming,
                    and a lot more impactful.
                  </p>
                </div>
                <div className="flex justify-center" data-id="element-50">
                  <div className="transform scale-110" data-id="element-51">
                    <a href="http://app.nisa.coach" data-id="element-52">
                      <Button type="button" size="lg" data-id="element-53">
                        Create a coach account
                        <ArrowRight className="w-5 h-5 ml-2" data-id="element-54" />
                      </Button>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};